import { render, staticRenderFns } from "./PurchasedAccProductListItem.vue?vue&type=template&id=bd251f06"
import script from "./PurchasedAccProductListItem.vue?vue&type=script&lang=js"
export * from "./PurchasedAccProductListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports